<template>
  <div>
    <CRow>
      <CCol md="12">
        <CRow>
          <CCol sm="12" lg="6">
            <CRow>
              <CCol sm="6">
                <CCallout color="info">
                  <medium>TOTAL ORDERS</medium>
                  <br>
                  <strong class="h2">{{totalOrders}}</strong>
                </CCallout>
              </CCol>
              <CCol sm="6">
                <CCallout color="secondary">
                  <medium>MONTHLY REVENUE</medium>
                  <br>
                  <strong class="h2">₹{{monthlyRevenue}}</strong>
                </CCallout>
              </CCol>
            </CRow>

          </CCol>
          <CCol sm="12" lg="6">
            <CRow>
              <CCol sm="6">
                <CCallout color="success">
                  <medium>TOTAL REVENUE</medium>
                  <br>
                  <strong class="h2">₹{{totalRevenue}}</strong>
                </CCallout>
              </CCol>
              <CCol sm="6">
                <CCallout color="primary">
                  <medium>ACTIVE ORDERS</medium>
                  <br>
                  <strong class="h2">{{activeOrders}}</strong>
                </CCallout>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </CCol>
    </CRow>

    <CRow style="margin-top: 40px">
      <CCol lg="7" md="12">
        <div>
          <h4 style="padding: 10px">REVENUE STATISTICS</h4>
          <CChartLine style="height:350px;margin-top:40px;margin-bottom: 20px"
                      :datasets="datasetsLineChartRevenue"
                      :options="optionsLineChartRevenue"
                      :labels=dailyOrdersDay
          />
        </div>
      </CCol>


      <CCol lg="5" md="12">
        <div>
          <h4 style="padding: 10px">SALES BY PRODUCT</h4>
          <CChartDoughnut style="height:350px;margin-top:40px; margin-bottom: 20px"
                          :datasets="datasetsPieProducts"
                          :labels=trendingProductsLables
          />
        </div>
      </CCol>
    </CRow>

    <CRow>


      <CCol lg="7" md="12" style="margin-top:40px;margin-bottom: 20px; margin-right: 20px">
        <h4 style="padding: 10px">ACTIVE ORDERS</h4>
        <CDataTable
          :fields="getFieldsForOrders()"
          :items="getRecentOrders()"
          border
          caption="Recent orders"
        />
      </CCol>

      <CCol lg="4" md="12" style="margin-top:40px;margin-bottom: 20px ; margin-left: 20px">
        <h4 style="padding: 10px">RECENT TRANSACTIONS</h4>
        <CDataTable
          :fields="getFieldsForPayments()"
          :items="getRecentPayments()"
          fixed
          border
          caption="Recent Transactions"
        />
      </CCol>

    </CRow>

  </div>
</template>

<script>
  import MainChartExample from './charts/MainChartExample'
  import WidgetsDropdown from './widgets/WidgetsDropdown'
  import WidgetsBrand from './widgets/WidgetsBrand'
  import {CChartLine, CChartDoughnut} from "@coreui/vue-chartjs";
  import CTableWrapper from "./base/Table";
  import {getColor} from "@coreui/utils/src";
  import Vue from "vue";

  export default {
    name: 'Dashboard',
    /*    beforeCreate() {
          console.log(this.$session);
          if(!this.$session.get('token')){
            this.$router.push("/pages/login")
          }
        },*/

    created() {
      console.log("home token")
      console.log("Token = " + Vue.prototype.$session.get('token'))
      this.getMonthlyRevenue();
      this.getOrdersCount();
      this.getTotalRevenue();
      this.getActiveOrders();
      this.getRecentOrdersFromServer();
      this.getRecentTransactionsFromServer();
      this.getTrendingProductsDataFromServer();
      this.getDailyOrdersDataFromServer();
    },


    components: {
      MainChartExample,
      WidgetsDropdown,
      WidgetsBrand,
      CChartLine,
      CChartDoughnut,
      CTableWrapper
    },

    data() {
      return {
        monthlyRevenue: 0,
        totalOrders: 0,
        totalRevenue: 0,
        activeOrders: 0,
        activeOrdersArr: [],
        dailyOrdersDay: [],
        dailyOrdersCount: [],
        dataSetDailyOrdersCount: [],
        trendingProductsLables: [],
        trendingProductsData: [],
        recentTransactionsArr: []
      }
    },
    methods: {

      async getMonthlyRevenue() {
        const response = await Vue.axios.get('/payment/getEarningThisMonth');
        // console.log(response)
        if (response.data.data)
          this.monthlyRevenue = response.data.data;
      },

      async getTotalRevenue() {
        const response = await Vue.axios.get('/payment/getEntireEarning');
        // console.log(response)
        if (response.data.data)
          this.totalRevenue = response.data.data;

      },
      async getActiveOrders() {

        const response = await Vue.axios.get('/dashboard/getActiveOrdersCount');
        // console.log(response)
        if (response.data.data)
          this.activeOrders = response.data.data;

      },

      async getOrdersCount() {

        const response = await Vue.axios.get('/dashboard/getAllOrdersCount');
        // console.log(response)
        if (response.data.data)
          this.totalOrders = response.data.data;

      },

      /*      getFieldsForOrders() {
              return ["orderId", "product", "customer", "address", "status"];
            },*/

      getFieldsForOrders() {
        return [
          {key: 'orderId', label: 'Order ID', _classes: 'text-center'},
          {key: 'productName', label: 'Product', _classes: 'text-center'},
          {key: 'customerName', label: 'Customer', _classes: 'text-center'},
          {key: 'address', label: 'Address', _classes: 'text-center'},
          {key: 'orderStateName', label: 'Status', _classes: 'text-center'}
        ]

      },

      getRecentOrders() {
        return this.activeOrdersArr;
      },

      async getRecentOrdersFromServer() {
        const response = await Vue.axios.get('/dashboard/getAllActiveOrders');
        // console.log(response)
        this.activeOrdersArr = response.data.data;
        // this.totalOrders = response.data.data;
      },

      async getRecentTransactionsFromServer() {
        const response = await Vue.axios.get('/payment/getRecentTransactions');
        // console.log(response)
        this.recentTransactionsArr = response.data.data;
        this.recentTransactionsArr.map(value => {
          value.finalPayoutPrice = "₹" + value.finalPayoutPrice;
        })
        // this.totalOrders = response.data.data;
      },

      async getDailyOrdersDataFromServer() {
        const response = await Vue.axios.get('/dashboard/getDataSetForDailyOrderCount');
        console.log(response.data.data)
        if (response.data.resultCode === 100 && response.data.data) {

          response.data.data = response.data.data.reverse().slice(0, 7).reverse()
          for (let index = 0; index < response.data.data.length; ++index) {
            console.log(response.data.data[index])
            this.dailyOrdersCount.push(response.data.data[index].orders)
            this.dailyOrdersDay.push(response.data.data[index].day)
          }
          console.log("orders = " + this.dailyOrdersCount)
          console.log("days = " + this.dailyOrdersDay)

          this.dataSetDailyOrdersCount = response.data.data;
        }
      },

      async getTrendingProductsDataFromServer() {
        const response = await Vue.axios.get('/dashboard/getDataSetForTrendingProducts');
        for (let index = 0; index < response.data.data.length; ++index) {
          this.trendingProductsData.push(response.data.data[index].count)
          this.trendingProductsLables.push(response.data.data[index].productName)
        }
      },


      getFieldsForPayments() {
        return [
          {key: 'orderId', label: 'Order ID', _classes: 'text-center'},
          {key: 'productName', label: 'Product', _classes: 'text-center'},
          {key: 'finalPayoutPrice', label: 'Amount', _classes: 'text-center'},
        ]
      },

      getRecentPayments() {
        return this.recentTransactionsArr;
      },


    },
    computed: {
      datasetsLineChartRevenue() {
        return [
          {
            label: 'Data One',
            backgroundColor: '#6C868C',
            borderColor: '#1E4040',
            pointHoverBackgroundColor: '#6C868C',
            borderWidth: 2,
            data: this.dailyOrdersCount
          }
        ]
      },
      datasetsPieProducts() {
        return [
          {
            backgroundColor: ['#6C868C', '#F2A25C', '#1E4040', '#D9B391'],
            data: this.trendingProductsData
          }
        ]
      },
      optionsLineChartRevenue() {
        return {

          maintainAspectRatio: false,
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              gridLines: {
                drawOnChartArea: false
              }
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                stepSize: 2,
                maxTicksLimit: 1,
                min: Math.min.apply(Math, this.dailyOrdersCount) - 5,
                max: Math.max.apply(Math, this.dailyOrdersCount) + 5
              },
              gridLines: {
                display: false
              }
            }]
          },
          elements: {
            point: {
              radius: 0,
              hitRadius: 10,
              hoverRadius: 4,
              hoverBorderWidth: 3
            }
          }
        }
      },
      /* getTrendingProductsLables() {
         console.log("Labels = " + this.getLablesForTrendingProducts());
         return this.getLablesForTrendingProducts();
       },*/
      getRevenueLables() {
        return this.getDatesForRevenue();
      }
    }
  }
</script>

<style>
  h4 {
    color: #012326;
  }
</style>
